import React from 'react';
import Icon from '../Icon';

type FileIconProps = {
  fileType: string;
  iconWidth?: number;
};

const FileIcon: React.FC<FileIconProps> = ({ fileType, iconWidth = 23 }) => {
  if (fileType.includes('spreadsheet')) {
    return <Icon type="antdFileExcelFilled" color="green8" width={iconWidth} />;
  }
  if (fileType.includes('wordprocessing')) {
    return <Icon type="antdFileWordFilled" color="primary" width={iconWidth} />;
  }
  if (fileType.includes('pdf')) {
    return <Icon type="antdFilePdfFilled" color="danger" width={iconWidth} />;
  }
  return <Icon type="antdFileImageFilled" color="gray8" width={iconWidth} />;
};

export default FileIcon;
